import { useAuth0 } from '@auth0/auth0-react';
import { useEffect, useState } from 'react';

interface UserState {
  email: string;
  name: string;
  nickname: string;
  picture: string;
  default_organization: {
    id: string;
    name: string;
    displayName: string;
  };
  organization: {
    id: string;
    name: string;
    displayName: string;
  };
  platform: {
    id: string;
    name: string;
    displayName: string;
  };
}

export const useUserData = () => {
  const { isAuthenticated, user } = useAuth0();
  const [userData, setUserData] = useState<UserState | null>(null);

  useEffect(() => {
    if (user && isAuthenticated) {
      Object.keys(user).forEach((key) => {
        if (key.includes(`${process.env.REACT_APP_IDENTIFIER}`)) {
          const newKey = key.replace(`${process.env.REACT_APP_IDENTIFIER}`, '');
          user[newKey] = user[key];
          delete user[key];
        }
      });

      setUserData({
        email: user.email!,
        name: user.name!,
        nickname: user.nickname!,
        picture: user.picture!,
        default_organization: user.default_organization!,
        organization: user.organization!,
        platform: user.platform!,
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [user]);

  return {
    user: userData,
  };
};
